import './styles.scoped.css'
import {useState} from 'react'
import {Typography, Tabs, Tab} from '@mui/material'
import {Backgrounds, ContactAndAddress, Demographics, EmploymentInfo, LanguageAndPreferences, AdditionalInfo} from './components'
import {useMobile} from '../../hooks'

export default () => {
    const [tab, setTab] = useState(0)
    const {mobile} = useMobile()

    return (
        <>
            {!mobile && (
                <>
                    <Typography variant="h6" color="text.primary">
                        Personal Information
                    </Typography>
                    <br />
                    <br />
                </>
            )}
            <Tabs
                value={tab}
                onChange={(e, newValue) => setTab(newValue)}
                allowScrollButtonsMobile
                variant={mobile ? 'scrollable' : 'fullWidth'}
                style={{width: mobile ? 420 : '100%'}}>
                <Tab label="Demographics" />
                <Tab label="Contact" />
                <Tab label="Employment Info" />
                <Tab label="Preferences" />
                <Tab label="Backgrounds" />
                <Tab label="Notes" />
            </Tabs>
            <br />
            <br />
            <div style={{display: tab != 0 ? 'none' : 'block'}}>
                <Demographics />
            </div>
            <div style={{display: tab != 1 ? 'none' : 'block'}}>
                <ContactAndAddress />
            </div>
            <div style={{display: tab != 2 ? 'none' : 'block'}}>
                <EmploymentInfo />
            </div>
            <div style={{display: tab != 3 ? 'none' : 'block'}}>
                <LanguageAndPreferences />
            </div>
            <div style={{display: tab != 4 ? 'none' : 'block'}}>
                <Backgrounds />
            </div>
            <div style={{display: tab != 5 ? 'none' : 'block'}}>
                <AdditionalInfo />
            </div>
        </>
    )
}
